module.exports = __webpack_public_path__ + "static/img/placeholder.efb3cda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placeholder.png
// module id = nsAd
// module chunks = 3